import { Fragment, ReactElement, useMemo } from 'react';
import { MarriageNotificationsResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { MarriageNotificationsResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { MarriageNotificationsResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { MarriageNotificationsResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { MarriageNotificationsResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchMarriageNotificationsShared from '../../research-notifications/research-marriage';

interface ResearchMarriageNotificationsCivilStatusSharedProps {
  scope?: string;
}

const ResearchMarriageNotificationsCivilStatusShared = ({
  scope,
}: ResearchMarriageNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/matrimonio/residenti/registrazione`;
  }, [goBackUrl]);

  const items = useMemo(() => {
    if (idCat) {
      return MarriageNotificationsResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return MarriageNotificationsResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return MarriageNotificationsResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return MarriageNotificationsResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return MarriageNotificationsResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <ResearchMarriageNotificationsShared
        goBackUrl={goBackUrl}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

ResearchMarriageNotificationsCivilStatusShared.displayName =
  'Research Marriage Notifications CivilStatusShared component';

export default ResearchMarriageNotificationsCivilStatusShared;
